module.exports = __webpack_public_path__ + "img/shouye.ce2b7cf2.png";